module.exports = __webpack_public_path__ + "static/media/2.507f0de8.jpeg";